import * as React from "react";

import { Flex, MainNavItem, VerticalToolbar } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { kNavLogo, kPoweredByLogo } from "@coreapp/whitelabel/brand";
import { getImagePath } from "@coreapp/utils/getImagePath";
import { useMainNavItems } from "./useMainNavItems";
import { useSettingsMenuOptions } from "./useSettingsMenuOptions";
import MainNavIcon from "./MainNavIcon";
import { SettingsMenu } from "./SettingsMenu";

const MainNavigation = () => {
  const { options, handleMainNavClick } = useMainNavItems();
  const { settingOptions, canAccessSettings, isWithinSettings, menuOpenCtrlRef } =
    useSettingsMenuOptions();

  const content = (
    <React.Fragment>
      {kPoweredByLogo && (
        <div className="powered-by-logo">
          <img src={getImagePath(kPoweredByLogo)} alt="Powered by Org Chart" />
        </div>
      )}
      <button className="ocn-logo-btn" onClick={() => handleMainNavClick(null)} aria-label="Home">
        <img className="responsiveImage" src={getImagePath(kNavLogo)} alt="Org Chart Logo" />
      </button>
      <nav
        className="oc-flex oc-flex-column oc-flex-1"
        aria-label="main navigation"
        role="navigation"
      >
        <Flex
          className={"ocn-list-scrollbar"}
          flex={"1"}
          direction="column"
          justifyContent="space-between"
        >
          <ul style={{ paddingLeft: "0px", margin: "0px", gap: "8px" }}>
            {options.map(item => (
              <li key={item.value} style={{ marginBottom: "8px" }}>
                <MainNavIcon item={item} />
              </li>
            ))}
          </ul>
          {settingOptions.length > 0 && canAccessSettings && (
            <div>
              <SettingsMenu
                trigger={
                  <MainNavItem
                    dataTestId={"settings-gear-menu"}
                    label={appstr("Settings")}
                    icon="gear"
                    checked={isWithinSettings}
                  />
                }
                settingOptions={settingOptions}
                canAccessSettings={canAccessSettings}
                menuOpenCtrlRef={menuOpenCtrlRef}
              />
            </div>
          )}
        </Flex>
      </nav>
    </React.Fragment>
  );

  return (
    <div className="oc-main-navigation-container">
      <VerticalToolbar
        size="small"
        modifier="gray"
        gap={"16px"}
        content={content}
        className={"oc-main-navigation-toolbar"}
      />
    </div>
  );
};

export default MainNavigation;
